module.exports = __webpack_public_path__ + "assets/img/sp4.ed09e544.jpg";